import React from 'react';


const Vehiculos = () => {
    return (  
        <h1>Desde Vehiculos</h1>
    );
}
 
export default Vehiculos;